<template>
  <div class="animated fadeIn">
    <b-card header-tag="header">
      <div slot="header">
        <i class="cui-file"></i> Contratos
        <b-link :to="actionUri" class="btn mr-2 btn-sm btn-primary float-right">
          <i class="fa fa-angle-left"></i>
          Voltar
        </b-link>
      </div>
      <b-card-body>
        <div class="alert alert-danger" role="alert" v-show="hasError">{{errorMessage}}</div>
        <form @submit.prevent="validate" class="needs-validation" novalidate>
          <div class="form-row">
            <div class="col-sm-12">
              <base-input
                type="text"
                label="Nome"
                required
                placeholder="Digite o nome do contrato"
                v-model="model.name"
                v-validate="modelValidations.name"
                data-vv-name="name"
                data-vv-as="nome"
                maxlength="255"
                :error="getError('name')"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="col-sm-12">
              <div class="form-group">
                <label>Descrição</label>
                <textarea
                  class="form-control"
                  v-model="model.description"
                  id="textarea-input"
                  name="textarea-input"
                  rows="9"
                  placeholder
                ></textarea>
              </div>
            </div>
          </div>
          <div class="form-row" style="display:none;">
            <div class="col-sm-3">
              <div class="form-group">
                <label>Segmento</label>
                <select
                  :class="{'form-control': true}"                  
                >
                  <option
                    v-for="(t, index) in segmentList"
                    :key="index"
                    :value="t.id"
                  >{{t.name}}</option>
                </select>                    
              </div>
            </div>
          </div>
          <div class="row" style="display:none;">
            <div class="col-sm-12">
              <div class="form-row">
                <div class="col-sm-3">
                  <div class="form-group">
                    <label>Tipo</label>
                    <select
                      :class="{'form-control': true, 'is-invalid': errors.has('deviceSettings.pixFee.paymentPeriod')}"
                      v-model="model.type"                      
                    >
                      <option
                        v-for="(t, index) in contractTypeList"
                        :key="index"
                        :value="t.id"
                      >{{t.name}}</option>
                    </select>                    
                  </div>
                </div>              
                <div class="col-sm-2">
                  <div class="form-group">
                    <label>Faturamento Mínimo</label>
                    <vue-numeric
                      :separator="vueNumericDefaults.separator"
                      :precision="vueNumericDefaults.decimals"
                      :output-type="vueNumericDefaults.outputType"
                      :disabled="model.type == 'CONTRACT'"
                      v-model="model.minCustomerRevenueForQuote"
                      v-validate="modelValidations.minCustomerRevenueForQuote"
                      data-vv-name="minCustomerRevenueForQuote"
                      data-vv-as="Fat. mínimo"
                      :class="{'form-control': true, 'is-invalid': errors.has('minCustomerRevenueForQuote') ? true : false}"
                    />
                    <div
                      v-show="errors.has('minCustomerRevenueForQuote')"
                      class="invalid-feedback"
                    >{{ errors.first('minCustomerRevenueForQuote') }}</div>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label>Faturamento Máximo</label>
                    <vue-numeric
                      :separator="vueNumericDefaults.separator"
                      :precision="vueNumericDefaults.decimals"
                      :output-type="vueNumericDefaults.outputType"
                      :disabled="model.type == 'CONTRACT'"
                      v-model="model.maxCustomerRevenueForQuote"
                      v-validate="modelValidations.maxCustomerRevenueForQuote"
                      data-vv-name="maxCustomerRevenueForQuote"
                      data-vv-as="Fat. máximo"
                      :class="{'form-control': true, 'is-invalid': errors.has('maxCustomerRevenueForQuote') ? true : false}"
                    />
                    <div
                      v-show="errors.has('maxCustomerRevenueForQuote')"
                      class="invalid-feedback"
                    >{{ errors.first('maxCustomerRevenueForQuote') }}</div>
                  </div>
                </div> 
                <div class="col-sm-8"></div>               
              </div>
            </div>
          </div>      
          <div class="form-row">
            <div class="col-sm-4">
              <div class="form-group">
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    v-model="model.automaticWithdrawal"
                    id="customSwitch3"
                  />
                  <label class="custom-control-label" for="customSwitch3">Repasse automático?</label>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-sm-4">
              <div class="form-group">
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    v-model="model.isSalesPersonFeeOnGrossAmount"
                    id="customSwitch13"
                  />
                  <label
                    class="custom-control-label"
                    for="customSwitch13"
                  >Comissão representante sob valor da transação?</label>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-sm-4">
              <div class="form-group">
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    v-model="model.status"
                    id="customSwitch2"
                  />
                  <label class="custom-control-label" for="customSwitch2">Ativo</label>
                </div>
              </div>
            </div>
          </div>          
          <br />
          <div class="row">
            <div class="col-sm-12">
              <b-tabs pills>
                <b-tab title="1. Presencial" active>                                        
                  <div class="row justify-content-start">                    
                    <div class="col-sm-5">
                      <h5>Taxas</h5>
                      <hr class="mb-3" />            
                      <div class="row">
                        <div class="col-sm-12 col-md-12">              
                          <h5 class="mt-3">Pix</h5>
                          <hr class="mb-3" />
                          <fee-input v-model="deviceSettings.pixFee" />
                        </div>                        
                        <div class="col-sm-12 col-md-12">
                          <h5 class="mt-3">Voucher</h5>
                          <hr class="mb-3" />
                          <fee-input v-model="deviceSettings.voucherFee" />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <h5 class="mt-3">Antecipação de recebíveis</h5>
                          <hr class="mb-3" />            
                          <div class="form-row">
                            <div class="col-sm-2">
                              <div class="form-group">
                                <label>RAV %</label>
                                <vue-numeric
                                  :separator="vueNumericDefaults.separator"
                                  :precision="vueNumericDefaults.decimals"
                                  :output-type="vueNumericDefaults.outputType"
                                  v-model="deviceSettings.advanceOnReceivables.partnerFee"
                                  v-validate="modelValidations.deviceAdvanceOnReceivables.partnerFee"
                                  data-vv-name="deviceAdvanceOnReceivables.partnerFee"
                                  data-vv-as="comissão"
                                  :class="{'form-control': true, 'is-invalid': errors.has('deviceAdvanceOnReceivables.partnerFee') ? true : false}"
                                />
                                <div
                                  v-show="errors.has('deviceAdvanceOnReceivables.partnerFee')"
                                  class="invalid-feedback"
                                >{{ errors.first('deviceAdvanceOnReceivables.partnerFee') }}</div>
                              </div>
                            </div>
                            <div class="col-sm-2">
                              <div class="form-group">
                                <label>Comissão %</label>
                                <vue-numeric
                                  :separator="vueNumericDefaults.separator"
                                  :precision="vueNumericDefaults.decimals"
                                  :output-type="vueNumericDefaults.outputType"
                                  v-model="deviceSettings.advanceOnReceivables.salesPersonFee"
                                  v-validate="modelValidations.deviceAdvanceOnReceivables.salesPersonFee"
                                  data-vv-name="deviceAdvanceOnReceivables.salesPersonFee"
                                  data-vv-as="comissão plataforma"
                                  :class="{'form-control': true, 'is-invalid': errors.has('deviceAdvanceOnReceivables.salesPersonFee') ? true : false}"
                                />
                                <div
                                  v-show="errors.has('deviceAdvanceOnReceivables.salesPersonFee')"
                                  class="invalid-feedback"
                                >{{ errors.first('deviceAdvanceOnReceivables.salesPersonFee') }}</div>
                              </div>
                            </div> 
                            <div class="col-sm-8"></div>               
                          </div>
                        </div>
                      </div>                   
                    </div>
                    <div class="col-sm-5">
                      <h5>Configurações</h5>
                      <hr class="mb-3" />                      
                      <div class="form-row">
                        <div class="col-sm-12">
                          <div class="form-group">
                            <div class="custom-control custom-switch">
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                v-model="deviceSettings.isRentalEnabled"
                                id="customSwitch1"
                              />
                              <label class="custom-control-label" for="customSwitch1">Aluguel Maquininha?</label>
                            </div>
                          </div>
                        </div>
                      </div>              
                      <div class="form-row justify-content-start">
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label>Custo perda POS</label>
                            <vue-numeric
                              :separator="vueNumericDefaults.separator"
                              :precision="vueNumericDefaults.decimals"
                              :output-type="vueNumericDefaults.outputType"
                              v-model="deviceSettings.replacementDeviceAmount"
                              :class="{'form-control': true}"
                            />
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="form-group">
                            <label>Isenção do aluguel a partir de:</label>
                            <vue-numeric
                              :disabled="!deviceSettings.isRentalEnabled"
                              :separator="vueNumericDefaults.separator"
                              :precision="vueNumericDefaults.decimals"
                              :output-type="vueNumericDefaults.outputType"
                              v-model="deviceSettings.rentalDefinitions.revenueConditionForRental"
                              v-validate="modelValidations.deviceSettings.revenueConditionForRental"
                              data-vv-name="revenueConditionForRental"
                              data-vv-as="Isenção do aluguel"
                              :class="{'form-control': true, 'is-invalid': errors.has('revenueConditionForRental') ? true : false}"
                            />
                            <div
                              v-show="errors.has('revenueConditionForRental')"
                              class="invalid-feedback"
                            >{{ errors.first('revenueConditionForRental') }}</div>
                          </div>
                        </div>                        
                      </div>                      
                      <div class="form-row">
                        <div class="col-sm-12">
                          <b-table show-empty :dark="false" :hover="true" :striped="true" :bordered="false" :small="false" :fixed="true" responsive :items="deviceRentalDefinitions" :fields="tableFields">
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="m-2 align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                            <template slot="amount" slot-scope="data">                                
                                <vue-numeric
                                  :disabled="!deviceSettings.isRentalEnabled"
                                  :separator="vueNumericDefaults.separator"
                                  :precision="vueNumericDefaults.decimals"
                                  :output-type="vueNumericDefaults.outputType"
                                  v-model="data.item.amount"
                                  @change="updateDeviceModelAmount(data.index, data.item.amount, $event)"
                                  :class="{'form-control': true}"
                                />
                            </template>                            
                          </b-table>
                        </div>
                      </div>                      
                    </div>
                  </div>
                  <div class="form-row justify-content-start">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <div class="custom-control custom-switch">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            v-model="deviceSettings.cardFees.usePaymentPeriodInstallment"           
                            id="customSwitch100"                     
                          />
                          <label class="custom-control-label" for="customSwitch100">Antecipação conforme parcelas</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <card-fee v-model="deviceSettings.cardFees" />
                </b-tab>
                <b-tab title="2. Web">
                  <div class="row">
                    <div class="col-sm-12">
                      <h5>Configurações</h5>
                      <hr class="mb-3" />                          
                    </div>
                  </div>
                  <div class="row justify-content-start">            
                    <div class="col-sm-6">                                     
                      <h5>Boleto</h5>
                      <hr class="mb-3" />
                      <fee-input v-model="webSettings.bankSlipFee" />
                    </div>
                    <div class="col-sm-6">
                      <h5>Antecipação de recebíveis</h5>
                      <hr class="mb-3" />            
                      <div class="form-row">
                        <div class="col-sm-2">
                          <div class="form-group">
                            <label>RAV %</label>
                            <vue-numeric
                              :separator="vueNumericDefaults.separator"
                              :precision="vueNumericDefaults.decimals"
                              :output-type="vueNumericDefaults.outputType"
                              v-model="webSettings.advanceOnReceivables.partnerFee"
                              v-validate="modelValidations.webAdvanceOnReceivables.partnerFee"
                              data-vv-name="webAdvanceOnReceivables.partnerFee"
                              data-vv-as="comissão"
                              :class="{'form-control': true, 'is-invalid': errors.has('webAdvanceOnReceivables.partnerFee') ? true : false}"
                            />
                            <div
                              v-show="errors.has('webAdvanceOnReceivables.partnerFee')"
                              class="invalid-feedback"
                            >{{ errors.first('webAdvanceOnReceivables.partnerFee') }}</div>
                          </div>
                        </div>
                        <div class="col-sm-2">
                          <div class="form-group">
                            <label>Comissão %</label>
                            <vue-numeric
                              :separator="vueNumericDefaults.separator"
                              :precision="vueNumericDefaults.decimals"
                              :output-type="vueNumericDefaults.outputType"
                              v-model="webSettings.advanceOnReceivables.salesPersonFee"
                              v-validate="modelValidations.webAdvanceOnReceivables.salesPersonFee"
                              data-vv-name="webAdvanceOnReceivables.salesPersonFee"
                              data-vv-as="comissão"
                              :class="{'form-control': true, 'is-invalid': errors.has('webAdvanceOnReceivables.salesPersonFee') ? true : false}"
                            />
                            <div
                              v-show="errors.has('webAdvanceOnReceivables.salesPersonFee')"
                              class="invalid-feedback"
                            >{{ errors.first('webAdvanceOnReceivables.salesPersonFee') }}</div>
                          </div>
                        </div> 
                        <div class="col-sm-8"></div>               
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <div class="custom-control custom-switch">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            v-model="webSettings.cardFees.usePaymentPeriodInstallment"
                            id="customSwitch101"                                
                          />
                          <label class="custom-control-label" for="customSwitch101">Antecipação conforme parcelas</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <card-fee v-model="webSettings.cardFees" />              
                </b-tab>
                <b-tab title="3. Dinheiro" v-if="isCashTransactionEnabled">
                  <div class="row">            
                    <div class="col-sm-12 col-md-12">                      
                      <h5>Dinheiro</h5>
                      <hr class="mb-3" />
                      <fee-input v-model="cashSettings.cashFee" />                      
                    </div>                    
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>           
          <template v-if="action == 'edit_contract'">
            <h4 class="mt-5">Historico</h4>
            <audit-list table="deviceContract" :primary-key="id"></audit-list>
          </template>
          <button type="submit" class="btn btn-primary">Salvar</button>
        </form>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import domainService from "../../../services/Contracts/contractService";
import payoutIntervalService from "../../../services/Partner/payoutIntervalService";
import deviceModelService from "../../../services/Devices/deviceModelService";
import editPage from "../../../mixins/editPage";
import auditList from "../../../components/AuditList";
import _ from "lodash";
import FeeInput from './FeeInput.vue';
import InstallmentFeeInput from './InstallmentFeeInput.vue'
import CardFee from './CardFee.vue';
import config from '../../../config';
import partnerService from '../../../services/Customer/partnerService';
export default {
  props: {
    id: String
  },
  components: {
    Datepicker,
    auditList,
    FeeInput,
    InstallmentFeeInput,
    CardFee
  },
  mixins: [editPage],
  data() {
    return {
      languages: lang,
      actionUri: "/partners/contracts",
      payoutIntervalList: [],
      partner: {
        bankSlipPlatformFee: 0,
        bankSlipTax: 0,
        cashPlatformFee: 0,
        cashTax: 0,
        creditPlatformFee: 0,
        creditTax: 0,
        debitPlatformFee: 0,
        debitTax: 0,
        deviceDisableDays: 15,
        pixPlatformFee: 0,
        pixTax: 0,
        voucherPlatformFee: 0,
        voucherTax: 0
      },
      tableFields: [
        {key: 'name', label: 'Maquininha', sortable: false},
        {key: 'amount', label: 'Valor Aluguel', sortable: false}
      ],
      contractTypeList: [
        {
          id: 'CONTRACT',
          name: 'Contrato'
        },
        {
          id: 'QUOTATION',
          name: 'Cotação'
        }
      ],
      segmentList: [
        {
          id: 1,
          name: 'Brinquedos e colecionáveis'
        },
        {
          id: 2,
          name: 'Eletrônicos'
        }
      ],
      deviceRentalDefinitions: [],
      model: {
        name: "",
        type: 'CONTRACT',
        maxCustomerRevenueForQuote: 0,
        minCustomerRevenueForQuote: 0,
        id: '',
        description: "",
        status: true,
        automaticWithdrawal: false,
        advanceOnReceivablesEnabled: false,
        isSalesPersonFeeOnGrossAmount: false,
        settings: []               
      },
      deviceSettings: this.createContractSettings('DEVICE'), 
      webSettings: this.createContractSettings('WEB'),
      cashSettings: this.createContractSettings('CASH'),
      vueNumericDefaults:{
        decimals: 2,
        separator: '.',
        outputType: 'Number'
      },
      modelValidations: {
        name: {
          required: true,
          max: 255
        },
        deviceAdvanceOnReceivables: {
          partnerFee: {required: true},
          salesPersonFee: {required: true},
        },
        webAdvanceOnReceivables: {
          partnerFee: {required: true},
          salesPersonFee: {required: true},
        },
        deviceSettings: {          
          
        }        
      }
    };
  },
  computed: {
    action() {
      return this.$route.name;
    },
    isCashTransactionEnabled() {
      return config.partnersConfiguration.transactions.addCash == true;
    },
    isPartnerTaxEnabled() {
      return config.partnersConfiguration.contracts.partnerTaxEnabled;
    }
  },
  async created() {
    await this.setDefaultSettings();
    await this.fetchData();  
  },  
  methods: {
    updateContractSettingsTaxes(){
      this.deviceSettings.pixFee.platformFee = this.partner.pixPlatformFee;
      this.deviceSettings.pixFee.partnerTax = this.partner.pixTax;
      this.deviceSettings.voucherFee.platformFee = this.partner.voucherPlatformFee;
      this.deviceSettings.voucherFee.partnerTax = this.partner.voucherTax;
      this.deviceSettings.cardFees.partnerSettings = {
        platformFee: this.partner.debitPlatformFee,
        partnerTax: this.partner.debitTax
      };
      this.webSettings.bankSlipFee.platformFee = this.partner.bankSlipPlatformFee;
      this.webSettings.bankSlipFee.partnerTax = this.partner.bankSlipTax;
      this.webSettings.cardFees.partnerSettings = {
        platformFee: this.partner.debitPlatformFee,
        partnerTax: this.partner.debitTax
      };
      this.cashSettings.cashFee.platformFee = this.partner.cashPlatformFee;
      this.cashSettings.cashFee.partnerTax = this.partner.cashTax;
    },
    async setDefaultSettings() {
      const response = await partnerService.current();
      const partner = response.data;
      this.showLoading();
      this.partner = partner.settings;      
      this.hideLoading();
    },
    async fetchData() {
      const self = this;
      self.showLoading();

      let result = await payoutIntervalService.all();      
      self.payoutIntervalList = result.data;
      
      result = await deviceModelService.all();      
      this.setDeviceRentalDefinitions(result.data);            

      if(this.action == "new_contract") {
        this.updateContractSettingsTaxes();
        self.hideLoading();
        return;
      }
      
      //edit
      let createFee = function(fee) {
        return {
          partnerFee: fee.partnerFee,
          salesPersonFee: fee.salesPersonFee,
          platformFee: fee.platformFee,
          partnerTax: fee.partnerTax,
          paymentPeriod: fee.paymentPeriod,
          usePaymentPeriodInstallment: fee.usePaymentPeriodInstallment
        }
      };
      
      domainService.findDetailed(this.id).then(
        response => {
          
          let sources = ['DEVICE', 'WEB', 'CASH'];
          self.model.type = response.data.type;
          self.model.name = response.data.name;
          self.model.id = response.data.id;
          self.model.description = response.data.description;
          self.model.status = response.data.status == 'ACTIVE' ? true : false;
          self.model.automaticWithdrawal = response.data.automaticWithdrawal;
          self.model.advanceOnReceivablesEnabled = response.data.advanceOnReceivablesEnabled;
          self.model.advanceOnReceivables = response.data.advanceOnReceivablesEnabled ? response.data.advanceOnReceivables : self.model.advanceOnReceivables;
          self.model.isSalesPersonFeeOnGrossAmount = response.data.isSalesPersonFeeOnGrossAmount;
          self.model.minCustomerRevenueForQuote = response.data.minCustomerRevenueForQuote;
          self.model.maxCustomerRevenueForQuote = response.data.maxCustomerRevenueForQuote;
          for(let idx = 0; idx <= sources.length - 1; idx++)
          {
            let setting = self.createContractSettings(sources[idx]);
            self.model.settings.push(setting);
            
            let responseSetting = _.find(response.data.settings, function(s) { return s.source == sources[idx] })
            
            switch(sources[idx])
            {
              case 'DEVICE':
                setting.cardFees.usePaymentPeriodInstallment = responseSetting.usePaymentPeriodInstallment;

                setting.isRentalEnabled = responseSetting.isRentalEnabled;  
                setting.rentalDefinitions = responseSetting.rentalDefinitions;
                setting.deviceModelRentalDefinitions = responseSetting.deviceModelRentalDefinitions;
                self.updateDeviceDefinitions(responseSetting.deviceModelRentalDefinitions);
                setting.replacementDeviceAmount = responseSetting.replacementDeviceAmount;

                setting.pixFee = responseSetting.fees.find(function(obj) { return obj.type == 6 });
                setting.voucherFee = responseSetting.fees.find(function(obj) { return obj.type == 4 });
                setting.cardFees.fees = responseSetting.fees.filter(function(obj) { return obj.type == 1 || obj.type == 2 });
                setting.cardFees.partnerSettings = {
                    platformFee: setting.cardFees.fees[0].platformFee,
                    partnerTax: setting.cardFees.fees[0].partnerTax
                };
                setting.advanceOnReceivables.partnerFee = responseSetting.advanceOnReceivables.partnerFee;
                setting.advanceOnReceivables.platformFee = responseSetting.advanceOnReceivables.platformFee;
                setting.advanceOnReceivables.salesPersonFee = responseSetting.advanceOnReceivables.salesPersonFee;
                self.deviceSettings = setting;
                break;
              case 'WEB':
                setting.cardFees.usePaymentPeriodInstallment = responseSetting.usePaymentPeriodInstallment;
                setting.bankSlipFee = responseSetting.fees.find(function(obj) { return obj.type == 3 });                    
                setting.cardFees.fees = responseSetting.fees.filter(function(obj) { return obj.type == 1 || obj.type == 2 });
                setting.cardFees.partnerSettings = {
                    platformFee: setting.cardFees.fees[0].platformFee,
                    partnerTax: setting.cardFees.fees[0].partnerTax
                };
                setting.advanceOnReceivables.partnerFee = responseSetting.advanceOnReceivables.partnerFee;
                setting.advanceOnReceivables.platformFee = responseSetting.advanceOnReceivables.platformFee;
                setting.advanceOnReceivables.salesPersonFee = responseSetting.advanceOnReceivables.salesPersonFee;
                self.webSettings = setting;
                break;
              case 'CASH':
                setting.bankSlipFee = responseSetting.fees.find(function(obj) { return obj.type == 5 });
                self.cashSettings = setting;
                break;
            }                                                    
          }
          if(!this.isPartnerTaxEnabled) {
            this.updateContractSettingsTaxes();
          }
                
          self.hideLoading();
        },
        () => {
          this.updateContractSettingsTaxes();
          self.hideLoading();
        }
      );
    },    
    validate() {
      const self = this;
      self.showLoading();
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          
          let postModel = {};
          postModel.id = self.model.id;
          postModel.type = self.model.type;
          postModel.name = self.model.name;
          postModel.description = self.model.description;
          postModel.status = self.model.status ? 'ACTIVE' : 'INACTIVE';
          postModel.isSalesPersonFeeOnGrossAmount = self.model.isSalesPersonFeeOnGrossAmount;
          postModel.automaticWithdrawal = self.model.automaticWithdrawal;
          postModel.partnerId = self.model.partnerId;
          postModel.settings = [];
          postModel.settings.push(self.transformSettings('DEVICE'));
          postModel.settings.push(self.transformSettings('WEB'));
          postModel.settings.push(self.transformSettings('CASH'));
          if (this.action == "new_contract") {
            domainService.create(postModel).then(
              () => {
                self.hideLoading();
                self.$router.push({ path: self.actionUri });
              },
              error => {
                self.showError(
                  error.response.data.message
                );
                self.hideLoading();
              }
            );
          } else {
            self.model.id = self.id;
            postModel.id = self.id;
            domainService.update(postModel).then(
              () => {
                self.hideLoading();
                self.$router.push({ path: self.actionUri });
              },
              error => {
                self.showError(
                  error.response.data.message
                );
                self.hideLoading();
              }
            );
          }
        } else {
          self.hideLoading();
        }
      });
    },
    setDeviceRentalDefinitions(list) {
      for(let i = 0; i <= list.length - 1; i++){
        this.deviceRentalDefinitions.push({  amount: 0.0, deviceId: list[i].id, name: list[i].name })
      }
    },
    updateDeviceDefinitions(list) {
      for(let i = 0; i <= this.deviceRentalDefinitions.length - 1; i++)
      {
        let definition = this.deviceRentalDefinitions[i];
        if(list.length == 0) {
          definition.amount = 0.0;          
        }
        else {
          let d = _.find(list, function(item) { return item.deviceId == definition.deviceId});
          if(d == null) continue;
          definition.amount = d.amount;          
        }        
        this.$set(this.deviceRentalDefinitions, i, definition);
      }    
    },
    updateDeviceModelAmount(index, amount, event){
      let item = this.deviceRentalDefinitions[index];
      item.amount = amount;
      this.$set(this.deviceRentalDefinitions, index, item);
    },    
    createFeeDefinitions(paymentMethodId, paymentMethodTypeId, installmentCount, source) {            
      return {
        partnerFee: 0,
        salesPersonFee: 0,
        platformFee: 0,
        partnerTax: 0,
        paymentPeriod: 1,
        paymentMethodId: paymentMethodId,
        type: paymentMethodTypeId,
        installmentCount: installmentCount,
        source: source
      }
    },
    createFeeDefinitionsValidation() {
      return {
        partnerFee: { required: true },
        salesPersonFee: { required: true },
        platformFee: { required: true },
        partnerTax: { required: true },
        paymentPeriod: { required: true }
      }
    },
    createContractSettings(source) {
      
      switch(source) {
        case 'DEVICE':
          return {
            source: source,
            isRentalEnabled: false,
            rentalDefinitions: {
              amount: 0,
              revenueConditionForRental: 0,
              dueDay: 5
            },            
            replacementDeviceAmount: 0,
            enabled: false,
            pixFee: this.createFeeDefinitions(0, 6, 1, source),
            voucherFee: this.createFeeDefinitions(0, 4, 1, source),
            cardFees: {
              source: 'DEVICE',
              fees: [],
              usePaymentPeriodInstallment: false,
              partnerSettings: {
                platformFee: 0,
                partnerTax: 0
              }
            },
            advanceOnReceivables: {
              partnerFee: 0,
              salesPersonFee: 0,
              platformFee: 0,
            } 
          }
        case 'WEB':
          return {
            source: source,
            isRentalEnabled: false,
            rentalDefinitions: {
              amount: 0,
              revenueConditionForRental: 0,
              dueDay: 5
            },
            replacementDeviceAmount: 0,
            enabled: false,
            bankSlipFee: this.createFeeDefinitions(0, 3, 1, source),
            cardFees: {
              source: 'WEB',
              fees: [],
              usePaymentPeriodInstallment: false,
              partnerSettings: {
                platformFee: 0,
                partnerTax: 0
              }
            },
            advanceOnReceivables: {
              partnerFee: 0,
              salesPersonFee: 0,
              platformFee: 0,
            } 
          }
        case 'CASH':
          return {
            source: source,
            isRentalEnabled: false,
            rentalDefinitions: {
              amount: 0,
              revenueConditionForRental: 0,
              dueDay: 5
            },
            replacementDeviceAmount: 0,
            enabled: false,        
            cashFee: this.createFeeDefinitions(0, 5, 1, source),
            advanceOnReceivables: {
              partnerFee: 0,
              salesPersonFee: 0,
              platformFee: 0,
            }        
          }
      }
    },
    transformSettings(source) {
      let setting = {};
      let fees = [];      
      switch(source)
      {
        case 'DEVICE':
          setting = _.clone(this.deviceSettings);
          fees = _.clone(setting.cardFees.fees);
          fees.push(setting.pixFee);
          fees.push(setting.voucherFee);
          break;
        case 'WEB':
          setting = _.clone(this.webSettings);
          fees = _.clone(setting.cardFees.fees);
          fees.push(setting.bankSlipFee);      
          break;
        case 'CASH':
          setting = _.clone(this.cashSettings);
          fees.push(setting.cashFee);
          break;
      }
      let transformedSetting = {
        replacementDeviceAmount: setting.replacementDeviceAmount,
        source: source,
        isRentalEnabled: setting.isRentalEnabled,
        rentalDefinitions: {
          amount: setting.rentalDefinitions.amount,
          revenueConditionForRental: setting.rentalDefinitions.revenueConditionForRental,
          dueDay: setting.rentalDefinitions.dueDay
        },
        deviceModelRentalDefinitions: source == 'DEVICE' ? this.deviceRentalDefinitions : [],
        enabled: setting.enabled,
        fees: fees,        
        usePaymentPeriodInstallment: source == 'CASH' ? false : setting.cardFees.usePaymentPeriodInstallment,
        advanceOnReceivables: setting.advanceOnReceivables  
      };          
      return transformedSetting;
    }
  }
};
</script>
